import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NotificationType } from '@app/shared/interfaces';
import { SmartlocksService } from '@app/shared/services/smartlocks/smartlocks.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-connect-new-smartlock-account',
  templateUrl: './dialog-connect-new-smartlock-account.component.html',
  styleUrls: ['./dialog-connect-new-smartlock-account.component.scss'],
})
export class DialogConnectNewSmartlockAccountComponent implements OnInit {
  integration_id: string;
  loading: boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogConnectNewSmartlockAccountComponent>,
    private smartlocksService: SmartlocksService,
    private toast: ToastNotificationsService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this.loading = false;
  }

  ngOnInit() { }

  okClicked() {
    this.loading = true;
    const payload = {
      integration_id: this.dialogData.integration_id,
    };

    this.smartlocksService.initiateNewSmartlockConnection(payload).subscribe((res) => {
      if (res.errors) {
        const errors = [];
        for (const [key, value] of Object.entries(res.errors)) {
          errors.push(value);
        }
        const errorMessage = errors.join(',');
        this.toast.open(errorMessage, 'Dismiss', NotificationType.Error);
        return;
      }

      this.redirectToOAuth(res.url);
    });
  }

  redirectToOAuth(url): void {
    window.location.href = url;
  }
}
